import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class RedirectGuard  {
  canActivate(next: ActivatedRouteSnapshot): boolean {
    if (next.data && next.data['redirectUrl']) {
      window.location.href = next.data['redirectUrl'];
      return false;
    }
    return true;
  }
}
